import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: "my-app",
  storage: localStorage
});

export default new Vuex.Store({
  state: {
    user: {
      logged: 0,
      data: ''
    },
    igv: 0,
    invoice: [],
    proforma: [],
    ordenpago: [],
    items: [],
    comprobante: 0, // 1: Factura; 2: Boleta; 3: Nota de credito; 4: Nota de debito; 5: Guias de remision; 6: Proformas; 7: Ordenes de Compra
    totalItems:[],
    datosGuiaAFacturas:[],
    infoFactura:{}
  },
  mutations: {
    setigv(state, igv) {
      state.igv = igv
    },
    setitems(state, data) {
      state.items = data
    },
    setcomprobante(state, data) {
      state.comprobante = data
    }, 
    setproforma(state, data){
      state.proforma = data
    },
    setemailpanel(state, data){
      state.emailpanel = data
    },
    setboleta(state, data,){
      state.boleta = data
    },
    setboletaGuias(state, data,){
      state.boletaG = data
    },
    setordenpago(state, data){
      state.ordenpago = data
    },
    datosRemitenteBoletaGuia(state, data){
      state.invoiceRemitenteBoletaGuia = data; //CONVIRTIENDO A GUIA, SE ENVIA EL REMITENTE DE LA BOLETA
    },
    datosRemitente(state, data){
      state.invoiceRemitente = data; //CONVIRTIENDO A GUIA, SE ENVIA EL REMITENTE DE LA FACTURA
    },
    itemstransient(state, data){
      state.invoice = data; //CONVIRTIENDO A GUIA, SE ENVIAN LOS ITEMS DE LA FACTURA
    },
    loginuser(state, data) {
      state.user.data = data;
      state.user.logged = 1;
    },
    logoutuser(state) {
      state.user.data = '';
      state.user.logged = 0;
    },
    listadoTotalItems(state, data) {
      state.totalItems = data
    },
    duplicarGuiaRemision(state, data){
      state.guiaDuplicada = data; //DUPLICAR GUIA REMISION DESDE EMITIDAS
    },
    duplicarGuiaRemisionItems(state, data){
      state.guiaDuplicadaItems = data; //DUPLICAR GUIA REMISION DESDE EMITIDAS
    },
    guiaAFacturas(state, data){
      state.datosGuiaAFacturas = data;
    },
    respuestaFactura(state, data){
      state.infoFactura = data;
    },
    banderaPDF(state, data){
      state.pdfFactura = data;
    },
  },
  getters: {
    getBanderaPDF: state => {
      return state.pdfFactura
    },
    getRespuestaFactura: state => {
      return state.infoFactura
    },
    getGuiaAFacturas: state => {
      return state.datosGuiaAFacturas
    },
    getDuplicarGuiaRemision: state => {
      return state.guiaDuplicada //RECIBE LOS DATOS DE LA GUIA
    },
    getDuplicarGuiaRemisionItems: state => {
      return state.guiaDuplicadaItems //RECIBE LOS ITEMS DE LA GUIA
    },
    getTotalItems: state => {
      return state.totalItems
    }, 
    getitems: state => {
      return state.items
    },
    getcomprobante: state => {
      return state.comprobante
    },  
    getproforma: state => {
      return state.proforma
    },
    getemailpanel: state => {
      return state.emailpanel
    },
    getboleta: state => {
      return state.boleta
    },
    getboletaGuias: state => {
      return state.boletaG
    },
    getordenpago: state => {
      return state.ordenpago
    },
    obtieneRemitenteBoletaGuia: state => {
      return state.invoiceRemitenteBoletaGuia //CONVIRTIENDO A GUIA, SE ENVIA EL REMITENTE DE LA BOLETA
    },
    obtieneRemitente: state => {
      return state.invoiceRemitente //CONVIRTIENDO A GUIA, SE ENVIA EL REMITENTE DE LA FACTURA
    },
    bringItems: state => {
      return state.invoice //OBTIENE LOS ITEMS DE LA FACTURA CONVERTIDA A GUIA
    },
    getPermisos: state => {
      return state.user.data.percepcion
    },
    userData: state => {
      return state.user.data.user
    },
    // SE AGREGO 
    guiaTransportista:state=>{
      return state.user.data.transportista
    },
    userDataRetencion: state => {
      return state.user.data.retencion
    },
    userMensajes: state => {
      return state.user.data.mensajes
    },
    userToken: state => {
      return state.user.data.token
    },
    userPermits: state => {
        return state.user.data.configuration
    }
  },
  actions: {},
  plugins: [vuexPersist.plugin]
});
